export { default as Newrelic } from './src/newrelic';
